import { combineReducers } from "redux";

import { StackPacksReducer } from "./stackPacks/StackPacksReducer";
import type { PagesState } from "./PagesState";
import { WelcomeReducer } from "./WelcomeSlice";

export const PagesReducer = combineReducers<PagesState>({
	stackPacks: StackPacksReducer,
	welcome: WelcomeReducer,
});
